import type {
  SearchFilterCondition,
  SearchFilterConditionDate,
} from 'lib-shared-types-api';

import { dateFilterFields } from '../../components/filters/utils/definitions';

/** Checks if the given condition is a date condition. */
export const isDateCondition = (
  condition: SearchFilterCondition,
): condition is SearchFilterConditionDate =>
  dateFilterFields.includes(
    condition.field as SearchFilterConditionDate['field'],
  );
